import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { city } from "./api-interfaces/city.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIcityService {
    ApiURL: string = "";
    constructor(private http: HttpClient, private helperService: HelperService) {
    this.ApiURL = environment.CityURL + 'Cities/';
    }
    public get(id: string): Observable<city[]>{ 
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
            return this.http.get<city[]>(this.ApiURL + encodeURIComponent(id),requestOptions);
       }

    public getForCountry(id: string): Observable<city[]>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        }; 
        return this.http.get<city[]>(this.ApiURL +"GetCitiesByCountry/"+ id,requestOptions);
   }
    public post(city:city): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.post<any>(this.ApiURL, city,requestOptions) 
    }
    public put(city:city): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
         return this.http.put<any>(this.ApiURL, city,requestOptions)
    }
    public delete(id: string):  Observable<any>{ 
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        let apiURL = `${this.ApiURL}${id}`; 
        return this.http.delete(apiURL,requestOptions)
    }
}